/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { isValidUUID } from '../../../utils/functions';

export interface IScoreItem {
  label: string;
  points: number;
  qnt_correct_answers?: number;
  question?: string;
  criterias?: string;
  correction_mode?: string;
  details?: any;
  type?: string;
}

export interface IClassificationItem {
  label: string;
  status: string;
  position: number;
}

export interface IEvaluator {
  evaluator_name: string;
  grade: number;
  original_total: number;
  normalized_score: number;
  status: string;
  evaluation_date: string;
  note_justification?: string | null;
  penalty?: {
    penalty_applied: number;
    final_score_with_penalty: number;
    quantity_in_minute: number;
    is_deadline_breached: boolean;
  };
  criteria?: {
    criterion_id: string;
    criterion_name: string;
    points_awarded: number;
    max_points: number;
    observation: string;
    selected_level: string;
  }[];
}

export interface IExamDataWithClassification {
  score: IScoreItem[];
  classification: IClassificationItem[];
  evaluators?: IEvaluator[];
}

export interface IExamStep {
  proof_type: string;
  name: string;
  type: 'Final' | 'Preliminar';
  data: IExamDataWithClassification | IScoreItem[];
  show_reserved_vacancies_preliminary_result?: boolean;
  show_reserved_vacancies_final_result?: boolean;
}

export interface IExamFinalResult {
  npo: number | null;
  npt: number | null;
  npd: number | null;
  npr: number | null;
  nf: number | null;
  name: string;
  data: IExamDataWithClassification | IScoreItem[];
}

export interface IExamResults {
  steps: IExamStep[];
  final: IExamFinalResult;
}

const getResultByStep = async (registrationId: string) => {
  if (!registrationId || !isValidUUID(registrationId)) return;

  const response = await configApi.get<IExamResults>(`candidate-area/results/${registrationId}/`);
  return response.data;
};

export const useGetResultByStep = (registrationId: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['result_by_step', registrationId],
    queryFn: () => getResultByStep(registrationId),
    refetchOnWindowFocus: false,
    gcTime: 0,
    enabled: enabled,
  });
};
